'use client'

import { Builder } from '@builder.io/react'

import { SplitContentCard } from './SplitContentCard'

Builder.registerComponent(SplitContentCard, {
  name: 'SplitContentCard',
  noWrap: true,
  inputs: [
    {
      name: 'titleText',
      type: 'string',
      defaultValue: 'Title',
    },
    {
      name: 'checkList',
      friendlyName: 'Items',
      type: 'list',
      subFields: [
        {
          name: 'text',
          type: 'string',
          localized: true,
        },
      ],
      defaultValue: [],
    },
    {
      name: 'photoUrl',
      type: 'file',
      defaultValue:
        'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fa2175c4c26464ec1adf4eadcf5fababc',
    },
    {
      name: 'photoHeight',
      type: 'number',
      defaultValue: 480,
      helperText: 'The height of the photo section.',
    },
    {
      name: 'mobilePhotoHeight',
      type: 'number',
      defaultValue: 320,
      helperText: 'The height of the photo section on mobile.',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/columns-2.svg',
})
